import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ConfirmModal } from '../../../components/modal/confirm.modal';
import { formatNumber } from '../../../utils/util';
import { reportBelongedDetail } from '../../../api/report';

interface ReportbelongedDetailDto {
  companyId: number; // 회사 아이디
  arrivedAt: string; // 도착시
  halfDayAmount: number; // 반일 금액
  fullDayAmount: number; // 전일 금액
  goWorkTime: string; // 출근 시간
  leaveWorkTime: string; // 퇴근 시간
  dayType: string; // 작업 형태
  ryubeiVolume?: number; // 루베량 (optional)
  cycleVolume?: number; // 회전수 (optional)
  workAmount: number; // 작업 금액
  ausAmount?: number; // 요소수 금액 (optional)
  ausVolume?: number; // 요소수 주유량 (optional)
  refuelingAmount?: number; // 주유 가격 (optional)
  refuelingVolume?: number; // 주유량 (optional)
  operationDistance?: number; // 운행 거리 (optional)
  additionAmount?: number; // 추가 작업 금액 (optional)
  additionComment?: string; // 추가 작업 내용 (optional)
  totalAmount: number; // 총 수입 금액
  id: number; // 일보 아이디
  name: string; // 회사 이름
}

const UserDairyBelongedDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [detailData, setDetailData] = useState<ReportbelongedDetailDto | null>(
    null,
  );
  const history = useHistory();
  const location = useLocation();
  console.log(location);

  const [confirmModal, setConfirmModal] = useState(false);
  const handleConfirmClick = () => {
    setConfirmModal(true);
  };
  const handleConfirmClose = () => {
    setConfirmModal(false);
  };

  const orderRegist = () => {
    history.push({
      pathname: `/userDiary/belonged/update/${id}`,
    });
  };

  useEffect(() => {
    const getReportBelongedDetail = async () => {
      try {
        const response = await reportBelongedDetail(Number(id));
        console.log(response);
        setDetailData(response);
      } catch (error) {
        console.error(error);
      }
    };

    getReportBelongedDetail();
  }, []);

  return (
    <Container>
      <ul>
        <li>
          <div className="label">회사명</div>
          <div className="value">{detailData?.name}</div>
        </li>
        <li>
          <div className="label">도착 일자</div>
          <div className="value">{detailData?.arrivedAt}</div>
        </li>
        <li>
          <div className="default-cost-box">
            <span className="title">기준금액 설정</span>
            <div className="row-50">
              <div>
                <span className="label">반일</span>
                <span className="value">
                  {formatNumber(Number(detailData?.halfDayAmount))}
                </span>
              </div>
              <div>
                <span className="label">전일</span>
                <span className="value">
                  {formatNumber(Number(detailData?.fullDayAmount))}
                </span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div className="label">출근 시간</div>
          <div className="value">{detailData?.goWorkTime}</div>
        </li>
        <li>
          <div className="label">퇴근 시간</div>
          <div className="value">{detailData?.leaveWorkTime}</div>
        </li>
        <li>
          <div className="label">작업 형태</div>
          <div className="value">
            {detailData?.dayType === 'full' ? '전일' : '반일'}
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <div className="label">루베</div>
              <div className="value">
                {detailData?.ryubeiVolume || detailData?.ryubeiVolume === 0
                  ? detailData.ryubeiVolume === 0 ||
                    detailData.ryubeiVolume === null
                    ? '-'
                    : formatNumber(Number(detailData.ryubeiVolume))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">회전수</div>
              <div className="value">
                {detailData?.cycleVolume || detailData?.cycleVolume === 0
                  ? detailData.cycleVolume === 0 ||
                    detailData.cycleVolume === null
                    ? '-'
                    : formatNumber(Number(detailData.cycleVolume))
                  : '-'}
              </div>
            </div>
          </div>
        </li>
        <li className="no-pd">
          <div className="working-cost-box">
            <div className="label">작업 금액</div>
            <div className="value">
              <span className="won">₩</span>
              {formatNumber(Number(detailData?.workAmount))}
            </div>
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <div className="label">요소수 금액</div>
              <div className="value">
                {detailData?.ausAmount || detailData?.ausAmount === 0
                  ? detailData.ausAmount === 0 || detailData.ausAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.ausAmount))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">요소수 주유량</div>
              <div className="value">
                {detailData?.ausVolume || detailData?.ausVolume === 0
                  ? detailData.ausVolume === 0 || detailData.ausVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.ausVolume))
                  : '-'}
              </div>
            </div>
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <div className="label">주유 가격/L</div>
              <div className="value">
                {detailData?.refuelingAmount ||
                detailData?.refuelingAmount === 0
                  ? detailData.refuelingAmount === 0 ||
                    detailData.refuelingAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.refuelingAmount))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">주유량(L)</div>
              <div className="value">
                {detailData?.refuelingVolume ||
                detailData?.refuelingVolume === 0
                  ? detailData.refuelingVolume === 0 ||
                    detailData.refuelingVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.refuelingVolume))
                  : '-'}
              </div>
            </div>
          </div>
        </li>
        <li className="no-pd column">
          <div className="row-30">
            <div>
              <div className="label">운행 거리</div>
              <div className="value">
                {detailData?.operationDistance ||
                detailData?.operationDistance === 0
                  ? detailData.operationDistance === 0 ||
                    detailData.operationDistance === null
                    ? '-'
                    : formatNumber(Number(detailData?.operationDistance))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">추가 작업 금액</div>
              <div className="value">
                {detailData?.additionAmount || detailData?.additionAmount === 0
                  ? detailData.additionAmount === 0 ||
                    detailData.additionAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.additionAmount))
                  : '-'}
              </div>
            </div>
          </div>
          <div className="row-30">
            <div>
              <div className="label">추가 작업 내용</div>
              <div className="value">
                {detailData?.additionComment === null
                  ? '-'
                  : detailData?.additionComment}
              </div>
            </div>
          </div>
        </li>
        <li>
          <div className="label">총 수입 금액</div>
          <div className="value">
            <span className="won">₩</span>
            {formatNumber(Number(detailData?.totalAmount))}
          </div>
        </li>
      </ul>
      <ConfirmBtn onClick={handleConfirmClick}>수정 하기</ConfirmBtn>
      <AnimatePresence initial={false}>
        {confirmModal ? (
          <ConfirmModal
            handleConfirmClose={handleConfirmClose}
            confirmText="수정 하시겠습니까?"
            onClick={orderRegist}
          />
        ) : null}
      </AnimatePresence>
    </Container>
  );
};

export default UserDairyBelongedDetail;

// style
const Container = styled.div`
  padding: 0.6rem 1.5rem;
  > ul {
    margin-top: 0rem;
    padding: 2.4rem 1.5rem 7.4rem;
    border-radius: 1.6rem;
    box-shadow: 0 2px 5px 3px rgba(0, 0, 0, 0.05);
    position: relative;
    background-color: ${(props) => props.theme.textWhiteColor};
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    overflow: hidden;
    > li:not(:last-child) {
      display: flex;
      gap: 2.4rem;
      align-items: center;
      padding: 0 0.9rem;
      &.column {
        flex-direction: column;
        gap: 0.6rem;
        p.title {
          font-size: 1.3rem;
          font-weight: 600;
          display: flex;
          justify-content: flex-start;
          width: 100%;
          margin-top: 1rem;
        }
      }
      &.no-pd {
        padding: 0;
      }
      .label {
        min-width: 5.4rem;
        font-size: 1.2rem;
        font-weight: 600;
        color: ${(props) => props.theme.textAAAColor};
      }
      .value {
        font-size: 1.4rem;
        font-weight: 600;
        &.status {
          min-width: 4.2rem;
          color: ${(props) => props.theme.textWhiteColor};
          background-color: ${(props) => props.theme.btnBlueColor};
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.4rem;
          font-size: 1.1rem;
          border-radius: 1.1rem;
        }
      }
      .row-50 {
        display: flex;
        align-items: center;
        gap: 2.4rem;
        width: 100%;
        > div {
          flex: 1 1 auto;
          display: flex;
          align-items: center;
          font-size: 1.2rem;
          font-weight: 600;
          gap: 2.4rem;
          color: ${(props) => props.theme.textAAAColor};
          .value {
            color: ${(props) => props.theme.textBlackColor};
            font-size: 1.4rem;
            font-weight: 600;
          }
        }
      }
      .row-30 {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        width: 100%;
        > div {
          flex: 1 1 30%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 1.6rem 0;
          gap: 0.8rem;
          border-radius: 0.4rem;
          background-color: ${(props) => props.theme.gray10};
          .label {
            min-width: auto;
            color: ${(props) => props.theme.joinLabelColor};
          }
          .value {
            color: ${(props) => props.theme.btnBlueColor};
          }
        }
      }
      .default-cost-box {
        width: 100%;
        margin: 1.2rem 0;
        .title {
          margin-bottom: 0.8rem;
          display: flex;
          font-size: 1.4rem;
          font-weight: 600;
        }
        .row-50 {
          gap: 0.8rem;
          > div {
            background-color: ${(props) => props.theme.costBgColor};
            border-radius: 0.4rem;
            color: ${(props) => props.theme.btnBlueColor};
            padding: 1.5rem 1.2rem 1.4rem;
            justify-content: center;
            .label {
              min-width: auto;
              color: ${(props) => props.theme.joinLabelColor};
            }
          }
        }
      }
      .working-cost-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1.1rem 1.3rem;
        background-color: ${(props) => props.theme.homeMainBoxBgColor};
        border-radius: 0.8rem;
        color: ${(props) => props.theme.textWhiteColor};
        margin: 0.6rem 0 1.2rem;
        .label {
          color: ${(props) => props.theme.textWhiteColor};
          font-size: 1.3rem;
        }
        .value {
          display: flex;
          gap: 0.4rem;
          align-items: baseline;
          font-size: 1.6rem;
          font-weight: 600;
          .won {
            font-size: 1.2rem;
            color: ${(props) => props.theme.workingTypeColor};
          }
        }
      }
    }
    > li:last-child {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 1.4rem;
      width: 100%;
      background-color: ${(props) => props.theme.btnBlueColor};
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${(props) => props.theme.textWhiteColor};
      .label {
        font-size: 1.3rem;
        font-weight: 600;
      }
      .value {
        display: flex;
        gap: 0.4rem;
        align-items: baseline;
        font-size: 1.6rem;
        font-weight: 600;
        .won {
          font-size: 1.2rem;
          color: ${(props) => props.theme.workingTypeColor};
        }
      }
    }
  }
`;

const ConfirmBtn = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 9.4rem;
  border: none;
  outline: none;
  padding: 1.7rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: ${(props) => props.theme.btnStrongBlueColor};
  color: ${(props) => props.theme.textWhiteColor};
  font-size: 1.8rem;
  font-weight: 600;
`;
